import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  vehicleList: [],
  vehicleById: {},
  vehicleByType: [],

  loading: {
    create: false,
    read: false,
    update: false,
    delete: false,
    getById: false,
    vehicleType: false,
    
  },
  error: false,
  errorMessage: "",
};

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {
    getVehicleList(state, action) {
      state.vehicleList = action.payload;
      state.loading.read = false;
      state.error = false;
    },
    vehicleById(state, action) {
      state.vehicleById = action.payload;
      state.loading.getById = false;
      state.error = false;
    },
    vehicleByType(state, action) {
      state.vehicleByType = action.payload;
      state.loading.vehicleType = false;
      state.error = false;
    },
    errorMessages(state, action) {
      state.errorMessage = action.payload;
      state.error = true;
      Object.keys(state.loading).forEach((key) => {
        state.loading[key] = false;
      });
    },
    hideErrorMessage(state) {
      state.error = false;
      state.errorMessage = "";
    },
    setLoading(state, action) {
      const { type, value } = action.payload;
      state.loading[type] = value;
    },
  },
});

export const {
  getVehicleList,
  vehicleById,
  vehicleByType,
  errorMessages,
  setLoading,
  hideErrorMessage,
} = vehicleSlice.actions;

export default vehicleSlice.reducer;
export const vehicleReducer = vehicleSlice.reducer;